/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum InternalApiAlertDecisionRuleCommand {
    ALL_ARE = 'ALL_ARE',
    AT_LEAST_ONE_IS = 'AT_LEAST_ONE_IS',
    NONE_ARE = 'NONE_ARE'
}


export function instanceOfInternalApiAlertDecisionRuleCommand(value: any): boolean {
    for (const key in InternalApiAlertDecisionRuleCommand) {
        if (Object.prototype.hasOwnProperty.call(InternalApiAlertDecisionRuleCommand, key)) {
            if (InternalApiAlertDecisionRuleCommand[key as keyof typeof InternalApiAlertDecisionRuleCommand] === value) {
                return true;
            }
        }
    }
    return false;
}

export function InternalApiAlertDecisionRuleCommandFromJSON(json: any): InternalApiAlertDecisionRuleCommand {
    return InternalApiAlertDecisionRuleCommandFromJSONTyped(json, false);
}

export function InternalApiAlertDecisionRuleCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiAlertDecisionRuleCommand {
    return json as InternalApiAlertDecisionRuleCommand;
}

export function InternalApiAlertDecisionRuleCommandToJSON(value?: InternalApiAlertDecisionRuleCommand | null): any {
    return value as any;
}

export function InternalApiAlertDecisionRuleCommandToJSONTyped(value: any, ignoreDiscriminator: boolean): InternalApiAlertDecisionRuleCommand {
    return value as InternalApiAlertDecisionRuleCommand;
}

